import client from '@libs/HttpClient';
class SprintService {
  static listAllSprint(request) {
    const projectId = request.id;
    const page_no = request.page_no;
    const searchText = request.searchText;
    const paymentStatusTypesID = request.paymentStatusTypesID;
    const profitibilityStatusID = request.profitibilityStatusID;
    return client.get(
      `/projects/view/${projectId}/sprint?search=${searchText}&page=${page_no}&payment_status_id=${paymentStatusTypesID}&profitibility_id=${profitibilityStatusID}`,
      request
    );
  }
  static deleteSprint(projectId, id) {
    return client.delete(`/projects/view/${projectId}/sprint/${id}`);
  }
  static addSprint(request) {
    const projectId = request.project_id;
    return client.post(`projects/view/${projectId}/sprint`, request);
  }
  static updateSprint(request) {
    const id = request.id;
    const projectId = request.project_id;
    return client.put(`/projects/view/${projectId}/sprint/${id}`, request);
  }
  static viewSprint(projectId,id) {
    return client.get(`/projects/view/${projectId}/sprint/${id}/edit`);
  }
  static sprintStatusTypes() {
    return client.get('/get-sprint-status-type');
  }
  static paymentStatusTypes() {
    return client.get('/get-payment-status-type');
  }
  static profitabilityStatusTypes() {
    return client.get('/get-profitability-status-type');
  }
  static sprintStatusUpdate(request) {
      const projectId = request.id;
      const sprintId = request.sprint_id;
      return client.post(`/projects/view/${projectId}/complete-sprint/${sprintId}`);
  }
  static deliveryManagerProjects(params) {
    return client.get(`/project-delivery-manager`, { params });
  }
}
export { SprintService };
